<mat-toolbar color="accent">
  <span>{{ dialogTitle() }}</span>
</mat-toolbar>

<mat-dialog-content>
  <div class="flex flex-col gap-4">
    @if (!hasRecipientEmail()) {
      <pr-information-box theme="warn">
        No email address configured for the recipient. Please update the contact
        details before sending.
        <button mat-flat-button (click)="editContact()">Edit Contact</button>
      </pr-information-box>
    }

    <mat-form-field class="w-full">
      <mat-label>To</mat-label>
      <input
        matInput
        type="email"
        [value]="data.recipientEmail || 'No email configured'"
        [disabled]="true"
      />
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>Subject</mat-label>
      <input
        matInput
        type="text"
        placeholder="Email subject"
        [formControl]="form.controls.subject"
      />
    </mat-form-field>

    <mat-form-field class="w-full" subscriptSizing="dynamic">
      <mat-label>Message</mat-label>
      <pr-content-editor
        class="w-full"
        placeholder="Compose your email message..."
        format="email"
        [menuEnabled]="true"
        [menuItems]="menuItems"
        [formControl]="form.controls.content"
      />
    </mat-form-field>

    <pr-information-box>
      A link to view the referral will be automatically included in the email.
    </pr-information-box>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <pt-buttons-container padding="none">
    <button mat-stroked-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="!canSend()"
      (click)="send()"
    >
      <mat-icon>send</mat-icon>
      Send
    </button>
  </pt-buttons-container>
</mat-dialog-actions>
